module.exports = {
  FETCH_FEATURE_FLAGS: 'FETCH_FEATURE_FLAGS',
  FETCH_FEATURE_FLAGS_SUCCESS: 'FETCH_FEATURE_FLAGS_SUCCESS',
};
